/*
 * Lib Module BrowserDetect
 */

Lib.BrowserDetect = (function () {
    var self = {};

    var isMobile;
    var hasTouch;
    var isIE;

    $(Lib).on('document.ready', function () {
        if (self.isMobile()) {
            $('html').addClass('ismobile');
        }
    });

    /**
     * Test the user agent string to a few mobile strings to see if we are mobile
     * @returns {boolean}
     */
    self.isMobile = function () {
        if (typeof isMobile === 'undefined') {
            isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
        }
        return isMobile;
    };
    /**
     * Test wether the user has a touch device
     * @returns {boolean}
     */
    self.hasTouch = function () {

        if (typeof hasTouch === 'undefined') {
            try {
                document.createEvent("TouchEvent");
                hasTouch = true;
            } catch (e) {
                hasTouch = false;
            }
        }

        return hasTouch;
    };


    self.isIE = function () {

        if (typeof isIE === 'undefined') {

            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");

            isIE = (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./));

        }
        return isIE;
    };

    return self;

})();
